export default {
    "company_header": "Coordonnées de la société",
    "header_product_warning": "Vous inscrivez-vous pour le bon produit GrabCAD ? S’inscrire pour {0}",
    "label": {
        "first_name": "Prénom",
        "last_name": "Nom",
        "name": "Nom",
        "company_name": "Nom de la société",
        "university_name": "Nom de l'établissement scolaire",
        "role": "Rôle",
        "company_size": "Taille de la société",
        "phone_number": "Numéro de téléphone",
        "printer": "Possédez-vous une imprimante 3D ?",
        "student_printer": "Votre établissement scolaire possède-t-il une imprimante 3D ?",
        "uses_printer_for": "Pour quoi utilisez-vous votre imprimante 3D ?",
        "shop_owner": "Êtes-vous le/la responsable de la gestion de votre atelier de modèles ?",
        "shop_users_expected": "Combien de personnes passent commande auprès de votre atelier ?",
        "email": "E-mail",
        "email_confirm": "Confirmez l'e-mail",
        "email_again": "Ressaisissez l'e-mail",
        "password": "Mot de passe",
        "country": "Emplacement",
				"state": "État/Région",
        "password_confirm": "Confirmez le mot de passe",
        "password_again": "Ressaisissez le mot de passe",
        "password_hint": "Minimum 6 caractères",
        "interested_in": "Je suis plus particulièrement intéressé par...",
        "industry_vertical": "Secteur de l'industrie",
        "industry_level": "Poste professionnel",
        "business_email": "E-mail professionnel",
        "business_email_confirm": "Confirmez l'e-mail professionnel",
        "recaptcha": "Confirmez que vous n'êtes pas un robot",
        "industry_level_select": "Sélectionnez le poste professionnel",
        "company_size_select": "Sélectionnez la taille",
        "industry_vertical_select": "Sélectionnez le secteur de l'industrie"
    },
    "placeholders": {
        "name": "p .ex. Jean Dupont",
        "first": "Premier",
        "last": "Dernier",
        "email": "Saisissez l'e-mail",
        "email_confirm": "Ressaisissez l'e-mail",
        "password": "Saisissez le mot de passe",
        "company_name": "Saisissez le nom de l'entreprise",
        "university_name": "Saisissez le nom de l'établissement scolaire",
        "phone_number": "Saisissez le numéro de téléphone",
        "printer": "Choisissez une réponse",
        "country": "Sélectionnez votre pays",
				"state": "Sélectionner votre État ou votre région",
        "business_email": "Saisissez l'e-mail professionnel",
        "business_email_confirm": "Confirmez l'e-mail professionnel"
    },
    "terms": {
        "buy_now_text": "En cliquant sur « Next » (Suivant), vous confirmez que vous avez lu nos",
        "workbench_text": "En cliquant sur « Sign up for Workbench » (S'inscrire à Workbench), vous confirmez que vous avez lu nos",
        "print_text": "En cliquant sur « Sign up » (S'inscrire), vous confirmez que vous avez lu nos",
        "text": "En cliquant sur « Sign up for Community » (S'inscrire à Communauté), vous confirmez que vous avez lu nos",
        "link": "Conditions générales"
    },
	"software_terms": {
		"link": "Conditions d’utilisation du logiciel"
	},
    "privacy_policy": {
        "and": "et",
        "link": "Politique de confidentialité",
        "text": "et que vous les acceptez et vous y engagez."
    },
    "actions": {
        "next": "Suivant",
        "workbench_sign_up": "S'inscrire à Workbench",
        "sign_up_button": "Inscription",
        "shop_sign_up": "Demander un essai gratuit de GrabCAD Shop",
        "sign_up": "S'inscrire à Communauté",
        "cancel": "Annuler"
    },
    "error": {
        "name_empty": "Indiquez votre nom",
        "email_taken": "Cet e-mail est déjà enregistré. Connectez-vous ou choisissez un autre e-mail.",
        "email_empty": "Indiquez votre e-mail",
        "email_nomatch": "Les e-mails doivent correspondre",
        "email_look": "Indiquez un e-mail valide",
        "password_nomatch": "Les mots de passe doivent correspondre",
        "password_short": "Le mot de passe est trop court. Il doit compter au moins 6 caractères.",
        "password_empty": "Saisissez votre mot de passe",
        "recaptcha": "Cochez la case pour confirmer que vous n'êtes pas un robot",
        "country_blocked": "Malheureusement, vous n'êtes pas autorisé à vous inscrire pour GrabCAD",
        "blank": "doit être renseigné"
    },
    "active": {
        "email": "Saisissez votre e-mail réel, où nous pourrons vous envoyer le lien de confirmation du compte."
    },
    "own_printer": {
        "default": {
            "no_dont_plan": "Non, et ce n'est pas dans mes projets",
            "no_but_interesed": "Non, mais je suis intéressé",
            "yes_for_work": "Oui, au travail",
            "yes_as_hobby": "Oui, uniquement pour les loisirs",
            "yes_for_other": "Oui, pour d'autres raisons"
        },
        "student": {
            "no_dont_plan": "Non, mon établissement scolaire n'est pas intéressé par l'impression 3D",
            "no_but_interesed": "Non, mais mon établissement scolaire recherche actuellement une imprimante 3D",
            "yes_they_do": "Oui",
            "not_sure": "Je ne sais pas"
        }
    },
    "uses_printer_for": {
        "professional": "Utilisation professionnelle",
        "education": "Enseignement/recherche",
        "hobby": "Loisirs",
        "dont_use": "Je n'utilise pas d'imprimante 3D"
    },
    "level_values": {
        "administrator_principal_superintendent": "administrateur",
        "biomedical_engineer": "ingénieur biomédical",
        "c_level_executive": "comité executif",
        "clinical_preclinical": "précliniques / cliniques",
        "dean_department_head": "doyen/ chef de département",
        "dentist": "Chirurgien Dentiste",
        "designer": "Designer",
        "educator": "Formateur",
        "engineer": "Ingénieur",
        "equipment_manufacturer": "fabricant de matériel",
        "lab_owner": "Responsable de laboratoire",
        "lab_technician": "Technicien de laboratoire",
        "marketing": "Marketing",
        "medical_education_and_training": "Enseignement médical et formation",
        "parent": "Parent",
        "practicing_physician": "Medecin en exercice",
        "president_provost": "Président/recteur",
        "prosthetist_orthotist": "Prothésiste / orthodontiste",
        "purchasing": "Achats",
        "quality": "Qualité",
        "rd_engineering": "R&D / Ingénieurie",
        "sales": "Ventes",
        "senior_management_administration": "haute direction",
        "student": "Étudiant",
        "training": "Formation",
        "other": "Autre",
        "not_employed": "Sans emploi"
    },
    "industry_values": {
        "aerospace": "Aérospatial",
        "architecture": "Architecture",
        "arts_entertainment": "Art et spectacle",
        "automotive": "Automobile",
        "commercial_products": "Produits commerciaux",
        "consumer_electronics": "Appareils électroniques grand public",
        "consumer_goods": "Produits de consommation",
        "dental": "Dentaire",
        "education": "Éducation",
        "engineering_consulting_service": "Services de conseil en ingénierie",
        "government_military": "Gouvernement/Militaire",
        "industrial_equipment": "Équipement industriel",
        "jewelry": "Bijouterie",
        "medical_device": "Appareil ou équipement médical",
        "service_bureau": "Bureau de services",
        "toys": "Jouets",
        "reseller": "Revendeur",
        "other": "Autre"
    },
    "company_size": {
        "0 - 100": "0 - 100",
        "100 - 500": "100 - 500",
        "500 - 1,000": "500 - 1000",
        "1,000 - 2,500": "1000 - 2500",
        "2,500 - 5,000": "2500 - 5000",
        "5,000 - 10,000": "5000 - 10000",
        "10,000 - 15,000": "10 000 - 15 000",
        "15,000 - 20,000": "15 000 - 20 000",
        "20,000+": "20 000+",
        "not_company": "Hors entreprise"
    },
    "yes_no_values": {
        "yes": "Oui",
        "no": "Non"
    }
}
